/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SocialDrawerVisibilityResponse } from './SocialDrawerVisibilityResponse';
import {
    SocialDrawerVisibilityResponseFromJSON,
    SocialDrawerVisibilityResponseFromJSONTyped,
    SocialDrawerVisibilityResponseToJSON,
    SocialDrawerVisibilityResponseToJSONTyped,
} from './SocialDrawerVisibilityResponse';

/**
 * 
 * @export
 * @interface ListSocialDrawerVisibilityResponse
 */
export interface ListSocialDrawerVisibilityResponse {
    /**
     * 
     * @type {Array<SocialDrawerVisibilityResponse>}
     * @memberof ListSocialDrawerVisibilityResponse
     */
    visibility?: Array<SocialDrawerVisibilityResponse>;
}

/**
 * Check if a given object implements the ListSocialDrawerVisibilityResponse interface.
 */
export function instanceOfListSocialDrawerVisibilityResponse(value: object): value is ListSocialDrawerVisibilityResponse {
    return true;
}

export function ListSocialDrawerVisibilityResponseFromJSON(json: any): ListSocialDrawerVisibilityResponse {
    return ListSocialDrawerVisibilityResponseFromJSONTyped(json, false);
}

export function ListSocialDrawerVisibilityResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListSocialDrawerVisibilityResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'visibility': json['visibility'] == null ? undefined : ((json['visibility'] as Array<any>).map(SocialDrawerVisibilityResponseFromJSON)),
    };
}

export function ListSocialDrawerVisibilityResponseToJSON(json: any): ListSocialDrawerVisibilityResponse {
    return ListSocialDrawerVisibilityResponseToJSONTyped(json, false);
}

export function ListSocialDrawerVisibilityResponseToJSONTyped(value?: ListSocialDrawerVisibilityResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'visibility': value['visibility'] == null ? undefined : ((value['visibility'] as Array<any>).map(SocialDrawerVisibilityResponseToJSON)),
    };
}

